import React, { useEffect, useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import Icon from "@mdi/react";
import {
  mdiCheckboxBlank,
  mdiCheckboxOutline,
  mdiLockOutline,
  mdiChevronDown,
  mdiChevronRight,
} from "@mdi/js";
import { connect } from "react-redux";

import Layer from "./Layer";

const substackStyle = {
  fontWeight: "400",
  fontSize: "0.68rem",
  backgroundColor: "#353c4e24",
};

const substrackTitle = {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
};

const checkSubstack = {
    marginRight: "8px",
    cursor: "pointer",
};

const ueLayerChevron = {
    backgroundColor: "#2B3536",
    borderRadius: "4px",
    padding: "1px 3px",
    width: "16px",
    height: "16px",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "12px",
};

const HeadingsStack = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [locked, setLocked] = useState(false);
  // isChecked => heading’s checkbox
  const [isChecked, setIsChecked] = useState(false);

  // If “any child layer” is in store => isChecked = true
  useEffect(() => {
    if (!Array.isArray(props.data)) return;
    const headingLayers = props.data.map((ly) => {
      const them = (ly.gs_thematique || "").trim();
      const lay = (ly.gs_layer || "").trim();
      return them + ":" + lay;
    });
    const anyActive = headingLayers.some((ref) =>
      props.layers_stack.includes(ref)
    );
    setIsChecked(anyActive);
  }, [props.data, props.layers_stack]);

  // Toggling the checkbox => add/remove all child layers
  const handleToggleCheck = (e) => {
    e.stopPropagation();
    if (!Array.isArray(props.data)) return;

    const headingLayers = props.data.map((ly) => {
      const them = (ly.gs_thematique || "").trim();
      const lay = (ly.gs_layer || "").trim();
      return them + ":" + lay;
    });
    if (isChecked) {
      headingLayers.forEach((ref) => props.removeLayerFromStack(ref));
    } else {
      headingLayers.forEach((ref) => props.addLayerToStack(ref));
    }
  };

  const toggleAccordion = () => setIsOpen(!isOpen);

  return (
    <Card className="ueThemeBackgroundAlternate">
      <div className="p-0 ueThemeBackgroundAlternate" style={substackStyle}>
        {locked ? (
          <div style={{ display: "flex", alignItems: "center", padding: "15px" }}>
            <Icon path={mdiLockOutline} color="#FFF" size={0.6} />
            <span style={{ marginLeft: "8px" }}>{props.title}</span>
          </div>
        ) : (
          <Accordion.Toggle
            as={Card.Body}
            id={`accordion_${props.refid}`}
            onClick={toggleAccordion}
            eventKey={props.title}
            style={{ padding: "15px" }}
          >
            <div
              className="w-100"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
               <div style={substrackTitle}>
                                    <div style={ueLayerChevron}>

                  {!isOpen ? (
                    <Icon path={mdiChevronRight} color={"#FFF"} size={0.4} />
                  ) : (
                    <Icon path={mdiChevronDown} color={"#FFF"} size={0.4} />
                  )}
                </div>
                <span>{props.title}</span>
              </div>

              {/* The heading's checkbox */}
              <div style={{ cursor: "pointer" }} onClick={handleToggleCheck}>
                {locked ? (
                  <Icon path={mdiLockOutline} size={0.8} color="#FFF" />
                ) : isChecked ? (
                  <Icon
                    path={mdiCheckboxOutline}
                    size={0.8}
                    color={"var(--theme-primary)"}
                  />
                ) : (
                  <Icon
                    path={mdiCheckboxBlank}
                    size={0.7}
                    color={"var(--theme-dark)"}
                  />
                )}
              </div>
            </div>
          </Accordion.Toggle>
        )}
      </div>

      <Accordion.Collapse eventKey={props.title}>
        <Card.Body className="p-0 pl-2" style={{ fontSize: "0.7rem" }}>
          <ul className="mt-2 pl-2">
            {Array.isArray(props.data) &&
              props.data.map((layerItem, idx) => (
                <div className="d-flex-block" key={idx}>
                  <Layer data={layerItem} />
                </div>
              ))}
          </ul>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  layers_stack: state.LayersReducer.layers_stack,
});

const mapDispatchToProps = (dispatch) => ({
  addLayerToStack: (layerRef) =>
    dispatch({ type: "ADD_LAYER_TO_STACK", data: layerRef }),
  removeLayerFromStack: (layerRef) =>
    dispatch({ type: "REMOVE_LAYER_FROM_STACK", data: layerRef }),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeadingsStack);
